/**
 * GB API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldMetaData } from './fieldMetaData';
import { RechteIdMeta } from './rechteIdMeta';
import { RechtVersionListEntryMeta } from './rechtVersionListEntryMeta';
import { RechtMasterIdMeta } from './rechtMasterIdMeta';


export interface RechtMasterListEntryMeta { 
    art?: RechtMasterListEntryMeta.ArtEnum;
    mArt?: FieldMetaData;
    rechteId: RechteIdMeta;
    mRechteId?: FieldMetaData;
    version?: RechtVersionListEntryMeta;
    mVersion?: FieldMetaData;
    isNavigierbar?: boolean;
    mIsNavigierbar?: FieldMetaData;
    id: RechtMasterIdMeta;
    mId?: FieldMetaData;
}
export namespace RechtMasterListEntryMeta {
    export type ArtEnum = 'DIENSTBARKEIT' | 'VORMERKUNG' | 'ANMERKUNG' | 'GRUNDLAST' | 'PFANDRECHT' | 'SDR_DIENSTBARKEIT' | 'EIGENTUM_ANTEIL';
    export const ArtEnum = {
        DIENSTBARKEIT: 'DIENSTBARKEIT' as ArtEnum,
        VORMERKUNG: 'VORMERKUNG' as ArtEnum,
        ANMERKUNG: 'ANMERKUNG' as ArtEnum,
        GRUNDLAST: 'GRUNDLAST' as ArtEnum,
        PFANDRECHT: 'PFANDRECHT' as ArtEnum,
        SDR_DIENSTBARKEIT: 'SDR_DIENSTBARKEIT' as ArtEnum,
        EIGENTUM_ANTEIL: 'EIGENTUM_ANTEIL' as ArtEnum
    };
}


